import vuetify from '@/plugins/vuetify';

/** The colours a brokerage can change. Pages use them as CSS variables, e.g. var(--c-brand). */
export const THEME_COLOURS = [
    { key: 'brand', label: 'Hoofkleur', hint: 'Knoppies, opskrifte en klem-kleur', default: '#f0848f' },
    { key: 'brandLight', label: 'Ligte hoofkleur', hint: 'Sagter weergawe van die hoofkleur', default: '#f4c0d1' },
    { key: 'brandWash', label: 'Hoofkleur-agtergrond', hint: 'Baie ligte agtergrond vir kolle', default: '#fcf0f1' },
    { key: 'text', label: 'Teks', hint: 'Hooftekskleur', default: '#2e2e2e' },
    { key: 'textSoft', label: 'Sagte teks', hint: 'Minder belangrike teks', default: '#5a5252' },
    { key: 'muted', label: 'Gedempte teks', hint: 'Byskrifte en klein teks', default: '#8a7f7e' },
    { key: 'border', label: 'Rande', hint: 'Lyne en rande', default: '#e9dcd9' },
    { key: 'background', label: 'Bladsy-agtergrond', hint: 'Agtergrond van die bladsye', default: '#faf6f5' },
] as const;

export type ThemeOverrides = Record<string, string>;

const CACHE_KEY = 'commonsense.theme';

/** Applies the defaults plus the given changes to the whole app. */
export function applyTheme(overrides: ThemeOverrides = {}) {
    const root = document.documentElement;
    const colours: Record<string, string> = {};
    for (const c of THEME_COLOURS) {
        colours[c.key] = overrides[c.key] || c.default;
        root.style.setProperty(`--c-${c.key}`, colours[c.key]);
    }
    const t = vuetify.theme.themes.value.janineLinde?.colors;
    if (t) {
        t.primary = colours.brand;
        t.secondary = colours.text;
        t.background = colours.background;
    }
}

export function applyAndCacheTheme(overrides: ThemeOverrides = {}) {
    applyTheme(overrides);
    try {
        localStorage.setItem(CACHE_KEY, JSON.stringify(overrides));
    } catch { /* storage unavailable: just no cache */ }
}

/** Last used colours, so the login page and first paint do not flash the defaults. */
export function applyCachedTheme() {
    let cached: ThemeOverrides = {};
    try {
        cached = JSON.parse(localStorage.getItem(CACHE_KEY) || '{}');
    } catch { /* ignore */ }
    applyTheme(cached);
}
